import { Container } from "./container";

export class Logging {

	constructor(readonly container: Container) { }

	error(error: any) {
		console.error(error);
	}

}
